import { render, staticRenderFns } from "./Figure.vue?vue&type=template&id=e742f5d8&scoped=true&"
import script from "./Figure.vue?vue&type=script&lang=ts&"
export * from "./Figure.vue?vue&type=script&lang=ts&"
import style0 from "./Figure.vue?vue&type=style&index=0&id=e742f5d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e742f5d8",
  null
  
)

export default component.exports